module.exports = __webpack_public_path__ + "static/media/OCFL-News-App-Icons.f29076ca.png";